import type { Messages } from '../catalogue.en'

export const localizedField: Partial<Messages> = {
  'localizedField.badge': 'השפות של הערך הזה',
  'localizedField.original': 'מקור',
  'localizedField.makeOriginal': 'הפיכה למקור',
  'localizedField.makeOriginalFor': 'הפיכת {language} למקור',
  'localizedField.remove': 'הסרת {language}',
  'localizedField.addLanguage': 'הוספת שפה',
  'localizedField.addLanguagePlaceholder': 'בחירת שפה',
  'localizedField.suggest': 'הצעה',
  'localizedField.suggestFor': 'הצעה עבור {language}',
  'localizedField.suggestAll': 'הצעה לכל השפות החסרות',
  'localizedField.suggesting': 'מכין הצעה…',
  'localizedField.suggestFailed': 'לא ניתן היה להכין את ההצעה. יש לנסות שוב.',
  'localizedField.sourceRequired': 'טקסט המקור הוא שדה חובה.',
  'localizedField.blank': 'יש להקליד את התרגום או להסיר את השפה.',
  'localizedField.tooLong': 'הטקסט ארוך מדי.',
  'localizedField.invalidText': 'הטקסט מכיל תווים שלא ניתן לשמור.',
  'localizedField.tooManyLanguages': 'לא ניתן להוסיף שפות נוספות לערך הזה.',
  'localizedField.shownIn': 'מוצג בשפה {language}',
}
